module.exports = __webpack_public_path__ + "static/media/CTLI_8-315w.1ce7bef6.jpg";